import React from "react";
import { Chip, Divider, Modal, Typography } from "@mui/material";
import Button from "components/atoms/Button";
import { CoverageAreaProps } from "store/modules/Logistics/types.store";
import * as Styled from "../styles";

interface CloseConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  selectedAreas: CoverageAreaProps[];
}

const CloseConfirmationModal: React.FC<CloseConfirmationModalProps> = ({
  open,
  onCancel,
  onConfirm,
  selectedAreas,
}) => {
  return (
    <Modal open={open} onClose={onCancel}>
      <Styled.ConfirmationModalContainer>
        <Typography variant="h6">Atenção</Typography>
        <Typography variant="body2">
          Você possui alterações não salvas. Deseja realmente fechar sem salvar?
        </Typography>
        <Divider sx={{ borderColor: "black" }} />
        <Typography variant="body2" fontWeight="bold">
          Revendas selecionadas:
        </Typography>
        <Styled.ChipsContainer>
          {selectedAreas.map((coverageArea) => (
            <Chip
              variant="outlined"
              key={coverageArea.id}
              label={coverageArea.name}
            />
          ))}
        </Styled.ChipsContainer>
        <Styled.ConfirmationModalButtonsContainer>
          <Button variant="outlined" color="inherit" onClick={onCancel}>
            Cancelar
          </Button>
          <Button variant="contained" color="primary" onClick={onConfirm}>
            Fechar sem salvar
          </Button>
        </Styled.ConfirmationModalButtonsContainer>
      </Styled.ConfirmationModalContainer>
    </Modal>
  );
};

export default React.memo(CloseConfirmationModal);
